<template>
    <div class="plugin-home-how-it-works-item swiper-slide">
        <div class="plugin-home-how-it-works-item__media">
            <img v-bind:src="item.image" alt="" />
        </div>
        <div class="plugin-home-how-it-works-item__content">
            <h3 class="plugin-home-how-it-works-item__content-title"
                v-text="item.title"
            />
            <div class="plugin-home-how-it-works-item__content-text" v-html="item.text" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'plugin-home-how-it-works-v2-item-b',
    props: {
        item: {
            type: Object,
        },
    },
    data: () => ({

    }),
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-how-it-works-item {
    position: relative;
    display: flex;
    width: 100%;
    // width: 920px;
    // max-width: 920px;
    height: 480px;

    border: 1px solid @color-gray-light-secondary;
    border-radius: 54px;

    background-color: white;
    overflow: hidden;

    &__media {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        img {
            width: 360px;
            margin: 0 36px;
        }
    }
    &__content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 0 36px;
        &-title {
            .typography-body-lg();
            margin: 0;
        }
        &-text {
            .typography-small();
        }
    }
    @media @media-md-down {
        flex-direction: column;
        width: 100%;
        max-width: 100%;
        height: auto;
        border-radius: @border-radius-xxl;
        &__media {
            width: 100%;
            height: 240px;
            overflow: hidden;
            img {
                width: 100%;
                padding: 0 24px;
            }
        }
        &__content {
            align-items: center;
            padding: 24px;
            text-align: center;
            &-title {
                .typography-small();
            }
            &-text {
                .typography-heading();
            }
        }
    }
}
</style>
